var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvancedSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "4ehnh94dta",
    d: "M7.26 12.05c-2.647 0-4.792-2.145-4.792-4.79 0-2.646 2.145-4.792 4.791-4.792 2.647 0 4.791 2.146 4.791 4.791 0 2.646-2.144 4.791-4.79 4.791zm6.833-.01l-1.235-.212c1.023-1.251 1.66-2.828 1.66-4.569C14.519 3.25 11.27 0 7.26 0 3.251 0 0 3.25 0 7.26s3.25 7.259 7.26 7.259c1.74 0 3.317-.638 4.567-1.66l.213 1.234 3.33 3.33 2.052-2.054-3.329-3.329z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    transform: "translate(-309 -679) translate(105 119) translate(160 552) translate(44 8)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-309 -679) translate(105 119) translate(160 552) translate(44 8) translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.111 7.111) translate(.178 .178)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mkkl1fsaob",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4ehnh94dta"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#A5A5A5",
    xlinkHref: "#4ehnh94dta"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#mkkl1fsaob)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H64V64H0z",
    transform: "translate(-10.647 -10.785)"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedSearch);
export default __webpack_public_path__ + "static/media/advancedSearch.92951143caf28bf4d5793c0a49fa072f.svg";
export { ForwardRef as ReactComponent };